import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  RESCHEDULE_REASON_MODAL_STAGES,
  rescheduleModalStageSelector,
  resetRescheduleModal,
} from 'features/classCreation';
import RescheduleModalStageRenderer from '../RescheduleModalStageRenderer';

function RescheduleReasonModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(rescheduleModalStageSelector);
  const isModalOpen = modalStage !== RESCHEDULE_REASON_MODAL_STAGES.notOpen;

  const handleClose = useCallback(() => {
    dispatch(resetRescheduleModal());
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleClose}
      withoutHeader
      className="p-m"
      size="large"
    >
      <RescheduleModalStageRenderer />
    </Modal>
  );
}

export default RescheduleReasonModal;
